/**
 * This module contains functions used to track when users are logged out sooner than we'd expect
 */

import { trackUntimelyLogout as trackUntimelyLogoutInOmniture } from 'lib/omniture';

const INITIAL_AUTHN_DATA_STORAGE_KEY = '@watch:INITIAL_AUTHN_DATA';
const AUTHN_TTL_STORAGE_KEY = '@watch:TTL_AUTHN';

// make the numbers look pretty in omniture
function formatTimeInMillisToDays(time) {
    if (typeof time === 'number') {
        return (time / 1000 / 60 / 60 / 24).toFixed(2);
    }
    return 'unknown';
}

// public function to tell us if we've already saved their authNTtl (to prevent overriding it)
export function isAuthNTtlSaved() {
    return !!localStorage.getItem(AUTHN_TTL_STORAGE_KEY);
}

// saves the time in which they authenticated, and which provider
export function saveInitialAuthNData({ name, abbreviation }) {
    if (localStorage) {
        localStorage.setItem(INITIAL_AUTHN_DATA_STORAGE_KEY, JSON.stringify({
            date: new Date(),
            provider: { name, abbreviation }
        }));
    }
}

// saves the expected TTL as returned from Adobe
export function saveAuthNTtl(ttl) {
    if (localStorage && typeof ttl === 'number') {
        localStorage.setItem(AUTHN_TTL_STORAGE_KEY, new Date(ttl));
    }
}

// clear out all storage keys related to untimely logout tracking
export function reset() {
    if (localStorage) {
        localStorage.removeItem(INITIAL_AUTHN_DATA_STORAGE_KEY);
        localStorage.removeItem(AUTHN_TTL_STORAGE_KEY);
    }
}

// get necessary items from localStorage and actually do the tracking
export function trackUntimelyLogout(entitlementsTracking) {
    if (localStorage) {
        try {
            const initialAuthNDataString = localStorage.getItem(INITIAL_AUTHN_DATA_STORAGE_KEY);
            const authNTtl = localStorage.getItem(AUTHN_TTL_STORAGE_KEY);

            if (authNTtl && initialAuthNDataString) {
                const initialAuthNData = JSON.parse(initialAuthNDataString);
                const provider = initialAuthNData.provider || {};
                const initialLoginTime = (new Date(initialAuthNData.date)).getTime();
                const loginExpireTime = (new Date(authNTtl)).getTime();
                const currentTime = (new Date()).getTime();

                const actualLoginTime = formatTimeInMillisToDays(currentTime - initialLoginTime);
                const expectedLoginTime = formatTimeInMillisToDays(loginExpireTime - initialLoginTime);
                // if the login expiration has not yet reached, the user got logged out unexpectedly
                if (loginExpireTime > currentTime) {
                    trackUntimelyLogoutInOmniture(
                        actualLoginTime,
                        expectedLoginTime,
                        provider,
                        entitlementsTracking
                    );
                }
                reset();
            }
        } catch (ex) {
            console.error(ex);
        }
    }
}



// WEBPACK FOOTER //
// ./app/lib/metrics/untimelyLogoutTracker.js